import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { ErrorMessage } from '../../common';
import { getErrorMessages } from '../../../utils';
import { TRootState } from '../../../reducers';
import { TFreelancerData, TPageNotification } from '../../../types';
import { executeHttpRequest } from '../../../epics/api';
import LoadingSpinner from '../../common/LoadingSpinner';


type RemoveFromListProps = {
    freelancers: TFreelancerData[];
    availabilityLists: { label: string, value: string | number }[];
    currentUrlParams: URLSearchParams;
    notification: TPageNotification;
    onActionSuccess: () => void;
    closeModal: () => void;
    reloadData: () => void;
};

type RemoveFromListState = {
    isLoading: boolean;
    error: string;
    selectedList: number;
};

class RemoveFromListContainer extends Component<
    RemoveFromListProps,
    RemoveFromListState
> {
    constructor(props: RemoveFromListProps) {
        super(props);

        const _selectedList = props.currentUrlParams.get('availability_lists');
        this.state = {
            isLoading: false,
            error: null,
            selectedList: _selectedList ? Number(_selectedList) : null,
        };
    }
    
    handleRemoveFromList = () => {
        this.setState({ isLoading: true });

        const payload = {
            freelancers: this.props.freelancers.map(fl => fl.id),
        };
        executeHttpRequest(
            `availability-lists/${this.state.selectedList}/remove/`,
            'patch',
            payload,
        ).then(response => {
            this.setState({ isLoading: false });
            const freelancersCount = this.props.freelancers.length;
            const listName = response.data.content.name;
            const successMessage = freelancersCount > 1
                    ? `Successfully removed ${freelancersCount} workers from ${listName}`
                    : `Successfully removed ${this.props.freelancers[0].full_name} from ${listName}`;
                this.props.notification.success('Success', successMessage);
                this.props.closeModal();
                this.props.onActionSuccess();
                this.props.reloadData();
        }).catch(error => {
            this.setState({
                error: getErrorMessages(error),
                isLoading: false,
            });
        });
    };

    render() {
        const freelancerCount = this.props.freelancers.length;
        const options = this.props.availabilityLists.filter(
            opt =>
                opt.value &&
                this.props.freelancers[0].availability_lists.find(id => id === opt.value)
        );

        return (
            <>
                <p className="modal-title">Remove from list</p>
                <div className="availability-action-body">
                    <p style={{ marginBottom: '15px' }}>{
                        `Please select a list from which you want to remove the selected worker${freelancerCount > 1 ? 's' : ''}`
                    }</p>
                    <Select
                        // @ts-ignore
                        value={this.state.selectedList}
                        clearable={false}
                        onChange={event =>
                            this.setState({ selectedList: event.value })}
                        options={options}
                    />
                </div>
                <button
                    className="btn btn--round-small"
                    type="button"
                    disabled={!this.state.selectedList || this.state.isLoading}
                    onClick={this.handleRemoveFromList}
                >
                    {this.state.isLoading ? (
                        <LoadingSpinner
                            className="mass-booking-spinner"
                            backgroundColor="white"
                        />
                    ) : (
                        'SELECT'
                    )}
                </button>
                <button
                    className="btn cancel-btn"
                    type="button"
                    onClick={this.props.closeModal}
                >
                    CANCEL
                </button>
                {this.state.error && (
                    <ErrorMessage message={this.state.error}/>
                )}
            </>
        );
    }
}

const mapStateToProps = (state: TRootState) => ({
    user: state.user,
});

export default connect(mapStateToProps)(RemoveFromListContainer);
